import { CHANNELS, type CommunicationChannel } from '@/api/channelInbox'
import { CHANNEL_META, type ChannelMeta } from '@/utils/channelInbox'

export type InboxChannel = CommunicationChannel | 'support'
export const INBOX_CHANNELS = [...CHANNELS, 'support'] as const
export const INBOX_CHANNEL_META: Record<InboxChannel, ChannelMeta> = {
  ...CHANNEL_META,
  support: { title: 'Поддержка', icon: '$avoCommunicationPortal', color: 'info' },
}
